import React, { useState } from "react"
import { Button, Form, Spinner } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import API from "@/common/API"
import { parsedUser } from "@/common/GetCurrentUser"
import { useToast } from "@/components/Common/Toast"

interface FeedComposerProps {
  mode: "comment" | "note"
  visitId?: string
  placeId?: string
  onPosted: (text: string) => void
  onCancel: () => void
}

const FeedComposer = ({ mode, visitId, placeId, onPosted, onCancel }: FeedComposerProps) => {
  const { t } = useTranslation("global")
  const { error: toastError } = useToast()
  const [text, setText] = useState("")
  const [saving, setSaving] = useState(false)

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    const value = text.trim()
    if (!value) return
    const user: any = parsedUser()
    setSaving(true)
    try {
      const res =
        mode === "comment"
          ? await API.postAction("PlaceVisitComment/AddEdit", {
              visitId,
              comment: value,
              accountId: String(user.ID),
              mentionedUserIds: [],
            })
          : await API.postAction("PlaceNote/AddEdit", { Id: null, PlaceId: placeId, Content: value })
      if (mode === "comment" && res.data?.status !== "ok") throw new Error("comment")
      setText("")
      onPosted(value)
    } catch {
      toastError(t("Actividad"), t("No se pudo guardar"))
    } finally {
      setSaving(false)
    }
  }

  return (
    <Form onSubmit={submit} className="feed-composer mt-2">
      <Form.Control
        as="textarea"
        rows={2}
        autoFocus
        value={text}
        disabled={saving}
        placeholder={mode === "comment" ? t("Escribe un comentario...") : t("Escribe una nota...")}
        onChange={e => setText(e.target.value)}
        onKeyDown={e => {
          if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) submit(e as any)
        }}
      />
      <div className="d-flex justify-content-end gap-2 mt-2">
        <Button size="sm" variant="light" onClick={onCancel} disabled={saving}>
          {t("Cancelar")}
        </Button>
        <Button size="sm" type="submit" disabled={saving || !text.trim()}>
          {saving ? <Spinner size="sm" animation="border" /> : mode === "comment" ? t("Comentar") : t("Guardar nota")}
        </Button>
      </div>
    </Form>
  )
}

export default FeedComposer
